import { $t } from "@/plugins/i18n";
const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: $t("menus.pureLogin"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/other/rentalCar",
    name: "rentalCar",
    meta: { title: "租车", showLink: false },
    component: () => import("@/views/other/rentalCar/index.vue")
  },
  {
    path: "/other/rentalCarEditForm",
    name: "rentalCarEditForm",
    meta: { title: "编辑租车信息", showLink: false },
    component: () => import("@/views/other/rentalCar/editForm.vue")
  },
  {
    path: "/other/rentalCarViewForm",
    name: "rentalCarViewForm",
    meta: { title: "编辑租车信息", showLink: false },
    component: () => import("@/views/other/rentalCar/viewForm.vue")
  },
  {
    path: "/redirect",
    component: Layout,
    meta: {
      title: $t("status.pureLoad"),
      showLink: false,
      rank: 102
    },
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "Redirect",
        component: () => import("@/layout/redirect.vue")
      }
    ]
  }
] satisfies Array<RouteConfigsTable>;
